function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

// https://govuk-loader-prototype.herokuapp.com/components/loader
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import { keyframes } from 'emotion';
import SVG from '../SVGBase/index';

var animationStyles = function animationStyles() {
  var fadeInOut = keyframes({
    '0%': {
      opacity: '0.250075'
    },
    '0.01%': {
      opacity: '0.25'
    },
    '0.03%': {
      opacity: '1'
    },
    '100%': {
      opacity: '0.250075'
    }
  });
  return {
    animation: fadeInOut + " 1s infinite linear"
  };
};

var Rect = styled('rect')(animationStyles);

var Spinner = function Spinner(_ref) {
  var className = _ref.className,
      fill = _ref.fill,
      title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["className", "fill", "title"]);

  return React.createElement(SVG, _extends({
    className: className,
    viewBox: "-25 -25 50 50",
    preserveAspectRatio: "xMidYMid meet",
    title: title,
    fill: fill
  }, rest), Array(12).fill(1).map(function (el, i) {
    return (
      /* eslint-disable-next-line react/no-array-index-key */
      React.createElement(Rect, {
        fill: fill,
        width: "12",
        height: "5",
        rx: "2.5",
        ry: "2.5",
        style: {
          animationDelay: i * 83 + "ms"
        },
        transform: "rotate(" + i * 30 + ", 0, 2) translate(10 0)",
        opacity: "0",
        key: i
      })
    );
  }));
};

Spinner.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string,
  title: PropTypes.string,
  fill: PropTypes.string
} : {};
Spinner.defaultProps = {
  className: 'icon-spinner',
  title: 'Loading',
  fill: 'currentColor'
};
export default Spinner;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/icons/es/Spinner/index.js
// module id = 72
// module chunks = 0